import {Component, Input, QueryList, ViewChildren} from '@angular/core';
import {DataTabs} from '../../models/tabs-data';
import {TabsComponent} from './tabs/tabs.component';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../../reducers';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import * as _ from 'lodash';
import {Role} from '../..';

@Component({
  selector: 'storever-generic-tabs',
  templateUrl: './generic-tabs.component.html',
  styleUrls: ['./generic-tabs.component.scss']
})
export class GenericTabsComponent {
  @ViewChildren(TabsComponent) tabsComponent: QueryList<TabsComponent>;
  @Input() tabsData: DataTabs;
  @Input() hideTabTile: boolean;
  roles$: Observable<Role[]>;

  constructor(private store: Store<fromRoot.AppState>) {
    this.roles$ = this.store.pipe(select(fromRoot.selectors.getMyRoles));

  }

  isInRole$(role: string): Observable<boolean> { return this.roles$.pipe(map(roles => _.findIndex(roles, ['code', role]) > -1)); }
}
